import { render } from "./ContentFeedbackDashboard.vue?vue&type=template&id=6cb02953&scoped=true"
import script from "./ContentFeedbackDashboard.vue?vue&type=script&lang=js"
export * from "./ContentFeedbackDashboard.vue?vue&type=script&lang=js"

import "./ContentFeedbackDashboard.vue?vue&type=style&index=0&id=6cb02953&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb02953"]])

export default __exports__